<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>

      <div class="content">
        <div class="container">
          <div class="floating-buttons">
            <router-link class="fl-button" :to="{ path: '/user/edit/' }"><i class="fa fa-plus"></i></router-link>
          </div>
          <h1>Felhasználók</h1>
          <div class="table-with-title">
            <h2>Felhasználók</h2>
            <table class="list">
              <thead>
                <tr>
                  <th>Név</th>
                  <th>Email</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="user in users">
                  <td>{{user.name}}</td>
                  <td>{{user.email}}</td>
                  <td class="buttons">
                    <router-link class="small-button" :to="{ path: '/user/edit/', query: { userID: user.element_id }}"><i class="fa fa-pencil-alt"></i></router-link>
                    <a class="small-button" href="javascript:void(0)" v-on:click="del(user.element_id)"><i class="fa fa-trash-alt"></i></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>
    <HTMLFooter></HTMLFooter>
  </div>
</template>
<script>
export default {
  components: {
  },
  data: function() {
    return {
      users: []
    }
  },
  mounted: function() {
    this.getUsers();
  },
  methods: {
    getUsers: function() {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('users/list/' + _this.$root.user.apikey + '/' + _this.$root.user.element_id, {
          success: function(response) {
            _this.users = response.users;
          }
        });
      });

    },
    del: function(id) {
      var _this = this;

      swal({
        title: 'Törli a felhasználót?',
        text: '',
        icon: 'warning',
        buttons:
        {
          confirm: {
            text: "Igen",
            value: true,
            closeModal: true
          },
          cancel: {
            text: "Nem",
            value: false,
            visible: true,
            closeModal: true
          }
        }
      }).then(function (result) {
        if (result) {
          _this.$root.ajax('user/del/' + _this.$root.user.apikey + '/' + id, {
            success: function(response) {
              _this.getUsers();
            }
          });
        }
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// users.vue?57f3c536